import React, {useEffect, useState} from 'react';
import Template from "../components/template/template";
import Error from "../components/appointment/Error";
import {useLocation} from "react-router-dom";
import {AppointmentState, AppointmentStates} from "../entities/Appointment";
import Success from "../components/appointment/Success";
import Waiting from "../components/appointment/Waiting";
import {getBookingState} from "../api/methods/slots/get/getBookingState";

const AppointmentResult = () => {
  const loc = useLocation();
  const search_params = new URLSearchParams(loc.search);
  const slot_id_string = search_params.get('id');
  const appointment_state_string = search_params.get('state');
  const [slot_id, setSlotId] =
    useState<number | null>(null);
  const [state, setState] =
    useState<AppointmentState>(AppointmentState.waiting);
  const [retry, goRetry] = useState<number>(1);

  useEffect(() => {
    if (slot_id_string && /^[0-9]+$/.test(slot_id_string)) {
      setSlotId(parseInt(slot_id_string));
    }
  }, [slot_id_string]);

  useEffect(() => {
    const appointment_state = parseInt(appointment_state_string ?? '');
    if (AppointmentStates.has(appointment_state) && state === AppointmentState.waiting) {
      setState(appointment_state);
    }
  }, [appointment_state_string]);

  useEffect(() => {
    if (!slot_id) return;
    if (state !== AppointmentState.waiting) return;
    getBookingState(slot_id)
      .then(({ data }) => {
        setState(data.state);
        setTimeout(() => goRetry(retry + 1), 5000);
      });
  }, [slot_id, state, retry]);

  return (
    <Template>
      {
        (state === AppointmentState.waiting || !slot_id) && <Waiting />
      }
      {
        state === AppointmentState.picked_up && slot_id && <Success slot_id={slot_id} />
      }
      {
        state === AppointmentState.cancelled && <Error />
      }
    </Template>
  );
};

export default AppointmentResult;